import { render } from "./SearchbarMenuItem.vue?vue&type=template&id=00e13566&ts=true"
import script from "./SearchbarMenuItem.vue?vue&type=script&lang=ts"
export * from "./SearchbarMenuItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__